var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zsxq"},[(_vm.facility=='app')?_c('div',{staticClass:"content"},[_c('AbApp')],1):_c('div',{staticClass:"pc"},[_c('Pc')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }